import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { makeTranslateService } from '../../../../data/services/common/translate/translate-service-factory';
import { LanguageKey } from '../../../../main/translate/language-key/language-key';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'app-button-save',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule, PipesModule],
  templateUrl: './button-save.component.html',
  styleUrls: ['./button-save.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonSaveComponent {
  public translateService = makeTranslateService();

  @Input() label: string = this.translateService.translateKey(LanguageKey.SAVE);
  @Input() loading: false;
  @Input() disabled: false;
}
